import { asyncThunkCreator, buildCreateSlice } from '@reduxjs/toolkit';
import { initialState } from './initial';
import { reducers } from './reducers';

export const createAppSlice = buildCreateSlice({
  creators: { asyncThunk: asyncThunkCreator },
});

export const liveblocksSlice = createAppSlice({
  name: 'liveblocks',
  initialState,
  reducers,
});

export const {
  setCommentingMode,
  toggleCommentingMode,
  requestCenterComment,
  centerCommentHandled,
  toggleShowCommentThreads,
  setCommentFilter,
  addOpenComment,
  removeOpenComment,
  clearOpenComments,
  setTargetThreadId,
  clearTargetThreadId,
} = liveblocksSlice.actions;

export default liveblocksSlice.reducer;
